import { render, staticRenderFns } from "./CommentProgress.vue?vue&type=template&id=d2a24910&"
import script from "./CommentProgress.vue?vue&type=script&lang=js&"
export * from "./CommentProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports